import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { createPortal } from 'react-dom';
var Portal = /*#__PURE__*/function (_React$Component) {
  function Portal() {
    _classCallCheck(this, Portal);
    return _callSuper(this, Portal, arguments);
  }
  _inherits(Portal, _React$Component);
  return _createClass(Portal, [{
    key: "maybeCreateNode",
    value: function maybeCreateNode() {
      if (!this.el) {
        this.el = document.createElement('div');
        this.el.classList.add('portal');
        document.body.appendChild(this.el);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.el) {
        document.body.removeChild(this.el);
      }
      this.el = null;
    }
  }, {
    key: "render",
    value: function render() {
      this.maybeCreateNode();
      return /*#__PURE__*/createPortal(this.props.children, this.el);
    }
  }]);
}(React.Component);
export { Portal as default };
//# sourceMappingURL=index.js.map
